module.exports = __webpack_public_path__ + "img/svg/background-deposit-modal.db52e7bf824028bb1fee4346e46a2154.svg";